import { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { useFocusEffect } from '@react-navigation/native';

import {
  fetchGlobalAlert,
  selectGlobalAlert,
  selectGlobalAlertDataState,
  selectShowGlobalAlert,
} from '../state';

export const useGlobalAlert = () => {
  const dispatch = useDispatch();
  const globalAlert = useSelector(selectGlobalAlert);
  const showGlobalAlert = useSelector(selectShowGlobalAlert);
  const globalAlertDataState = useSelector(selectGlobalAlertDataState);

  const returnObj = useMemo(
    () => ({
      id: globalAlert?.id,
      text: globalAlert?.text,
      showGlobalAlert,
      globalAlertDataState,
    }),
    [globalAlert, globalAlertDataState, showGlobalAlert],
  );

  useFocusEffect(
    useCallback(() => {
      dispatch(fetchGlobalAlert());
    }, [dispatch]),
  );

  return returnObj;
};

export default useGlobalAlert;
